import { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid, itIT, GridToolbar, useGridApiRef } from '@mui/x-data-grid';		//https://mui.com/x/react-data-grid/ [MIT version]
import { Slider, Box, Alert, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

import moment from 'moment';
import { useAuth } from '../../Auth/ProvideAuth'

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import EngineeringIcon from '@mui/icons-material/Engineering';

import Api from '../../Services/Api';
import {PAGE_SIZE, pageSizeOptions, OPERATOR_ROLE} from '../../Config/constants.js';
import ActionButton from '../ActionButton.js';

function AppointmentList(props) {
	const { hook, lastUpdate, dashboard } = props;
	let auth = useAuth();
	const apiRef = useGridApiRef();	//https://mui.com/x/api/data-grid/

	const [displayDialog, setDisplayDialog] = useState(0);
	const [displayDialogContent, setDisplayDialogContent] = useState(null);
	const [dayValue, setDayValue] = useState(0);

	const extraDataTags = {
		appointment_at: 'Data|date',
		appointment_type: 'Tipo|string',
        customer: 'Cliente|string',
		address: 'Città|string',
		technician: 'Tecnico|string',
	};

	let defaultColumns = [
		{
			field: 'cancelled',
			headerName: 'Cancellato',
			flex: 1,
			type: 'boolean',
			valueGetter: (params) => {
				return params.row.cancelled_at ? true : false
			},
		},
		{
			field: 'id',
			headerName: 'Azioni',
			flex: 1,
			renderCell: (params) => {
				function onEdit(e) {
					e.stopPropagation(); // don't select this row after clicking
					hook("edit", params.value);
				};
				function onDelete(e) {
					e.stopPropagation(); // don't select this row after clicking
					if (window.confirm("Confermare l'eliminazione DEFINITIVA dell'Appuntamento?")) {
						if (window.confirm("Eliminare l'Appuntamento?")) {
							hook("delete", params.value);
						}
					}
				};
				return <>
					<ActionButton title={"Modifica Appuntamento"} onClick={onEdit}>
						<EditIcon />
					</ActionButton>
					<ActionButton title={"Elimina Appuntamento"} onClick={onDelete}>
						<DeleteIcon />
					</ActionButton>
				</>
			}
		}
	];

	if (dashboard) {
		defaultColumns = [
			{
				field: 'id',
				headerName: 'Azioni',
				flex: 1,
				renderCell: (params) => {
					function onEdit(e) {
						e.stopPropagation(); // don't select this row after clicking
						hook("edit", params.value);
					};
					function onWork(e) {
						e.stopPropagation(); // don't select this row after clicking
						hook("work", params.value);
					};
                    function onShow(e) {
                        e.stopPropagation(); // don't select this row after clicking
                        setDisplayDialogContent(explodeData(apiRef.current.getAllColumns(params.value), params.value));
                        setDisplayDialog(1);
					};
					return <>
						{auth.lonyUser.roles[0].name !== OPERATOR_ROLE && (
							<ActionButton title={"Modifica Appuntamento"} onClick={onEdit}>
								<EditIcon />
							</ActionButton>
						)}
                        <ActionButton title={"Visualizza dettagli Appuntamento"} onClick={onShow}>
                            <InfoIcon />
                        </ActionButton>
						<ActionButton title={"Lavora Appuntamento"} onClick={onWork}>
							<EngineeringIcon />
						</ActionButton>
					</>
				}
			}
		]
	}

	const columns = [
		{
			field: 'appointment_at',
			headerName: 'Data',
			minWidth: 150,
			type: 'dateTime',
			valueGetter: (params) => params.row.appointment_at ? new Date(params.row.appointment_at) : null,
			valueFormatter: (params) => params.value ? params.value.toLocaleDateString('it-IT') + ' ' + params.value.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '',
		},
		{
			field: 'appointment_type',
			headerName: 'Tipo',
			flex: 1,
		},
		{
			field: 'customer',
			headerName: 'Cliente',
			flex: 2,
			valueGetter: (params) => {
				return params.row.customer_surname + " " + params.row.customer_name + " [Cod.impianto:" + params.row.unique_code + "]"
			},
		},
		{
			field: 'address',
			headerName: 'Città',
			flex: 2,
			valueGetter: (params) => {
				return (
					(params.row.installation_city ? params.row.installation_city : params.row.customer_city) +
					" [" +
					(params.row.installation_area ? params.row.installation_area : params.row.customer_area) + "]"
				);
			},
		},
		{
			field: 'technician',
			headerName: 'Tecnico',
			flex: 2,
			valueGetter: (params) => {
				return params.row.technician_name + " " + params.row.technician_surname
			},
		},
		{
			field: 'closed_appointment',
			headerName: 'Lavorato',
			valueGetter: (params) => {
				return params.row.closed_appointment === 1 ? 'SI' : 'NO';
			},
		},
        {
            field: 'created_at',
            headerName: 'Creato il',
            minWidth: 150,
            type: 'dateTime',
            valueGetter: (params) => params.row.created_at ? new Date(params.row.created_at) : null,
            valueFormatter: (params) => params.value ? params.value.toLocaleDateString('it-IT') + ' ' + params.value.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '',
        },
		...defaultColumns
	]


	const handleClose = () => {
		setDisplayDialog(0);
	};

	function explodeData(cols, rowId) {
		try {
			let output = "";
			cols.forEach((col) => {
                if (extraDataTags.hasOwnProperty(col.field)) {
                    let tag = extraDataTags[col.field].split('|');
                    let value = apiRef.current.getCellValue(rowId, col.field);

                    switch(tag[1]) {
                        case "date":
                            value = value ? moment(value).format('DD/MM/YYYY HH:mm') : "-";
                            break;
                        case "bool":
                            value = value ? "SI" : "NO";
                            break;
                        default: //string
                            value = value.replaceAll(/<\/?[^>]+(>|$)/gi, "");
                            break;
                    }
                    output += "<p><strong>" + tag[0] + ":</strong> " + value + "</p>";
                }
            });
			return output;
		} catch (error) {
			return "N/D";
		}
	}

	function newElement() {
		hook("create");
	}

	const [rows, setRows] = useState([]);
	const [displayAlert, setDisplayAlert] = useState(0);

	useEffect(() => {
		let endPoint = 'appointment';

		if (dashboard) {
			if ((dayValue || dayValue === 0) && dayValue >= -2 && dayValue <= 2) {
				endPoint += `?day=${dayValue}`;
			}
		}

		try {
			Api.get({endpoint: endPoint, contentType : 'application/json'})
			.then(response => {
				setRows(response.data.appointments);
			})
			.catch(error => {
				console.log(JSON.stringify(error));
				setDisplayAlert(-1);
			});
		} catch (error) {
			console.log(JSON.stringify(error));
			setDisplayAlert(-1);
		}
	}, [lastUpdate, dayValue]);	// eslint-disable-line react-hooks/exhaustive-deps

	const theme = createTheme({
			palette: {
				primary: { main: '#11cb5f' },
			},
		},
		itIT,
	);

	const marks = [
		{
			value: -2,
			label: 'Altroieri',
		},
		{
			value: -1,
			label: 'Ieri',
		},
		{
			value: 0,
			label: 'Oggi',
		},
		{
			value: 1,
			label: 'Domani',
		},
		{
			value: 2,
			label: 'Dopodomani',
		},
	];

	function hookDayValue(event, newValue) {
		setDayValue(newValue);
	}

	return (
		<>
			<h5 className={dashboard ? 'dashboard' : ''}>Appuntamenti {!dashboard && <span style={{fontSize: '0.8em'}}>(Ultimi 500 creati)</span>}</h5>
			{dashboard && (
				<div className="container">
					<Slider
						aria-label="Giorni"
						defaultValue={0}
						valueLabelDisplay="auto"
						valueLabelFormat={value => <div>Appuntamenti di:</div>}
						step={1}
						marks={marks}
						min={-2}
						max={2}
						onChange={hookDayValue}
					/>
				</div>
			)}
			<Box sx={{ width: '100%', minWidth: '800px' }}>
				<ThemeProvider theme={theme}>
					<DataGrid
						//onRowDoubleClick={hook}
						sx={{ minHeight: '300px' }}
						rows={rows}
						columns={columns}
						columnVisibilityModel={{
							technician: auth.lonyUser.roles[0].name !== OPERATOR_ROLE,
						}}
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: PAGE_SIZE,
								},
							},
						}}
						apiRef={apiRef}
						slots={{
							toolbar: GridToolbar,
						}}
						slotProps={{
							columnsPanel: {
								disableHideAllButton: true,
							},
							toolbar: {
								showQuickFilter: !dashboard
							}
						}}
						pageSizeOptions={pageSizeOptions}
					/>
					{!dashboard && (
						<div className="mt-2">
							<Button
								variant="contained"
								onClick={newElement}
							>
								Nuovo Appuntamento
							</Button>
						</div>
					)}
				</ThemeProvider>




			<Dialog
				open={displayDialog !== 0}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{displayDialogContent && displayDialog !== -1? (
					<>
						<DialogTitle id="alert-dialog-title">
							Dettagli dell'appuntamento
						</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								<div dangerouslySetInnerHTML={{ __html: displayDialogContent }} />
							</DialogContentText>
						</DialogContent>
					</>
				) : (
					<>
						<DialogTitle id="alert-dialog-title">
							{displayDialog === 1 && "Operazione completata"}
							{displayDialog === -1 && "Errore"}
						</DialogTitle>
						<DialogContent>
								<DialogContentText id="alert-dialog-description">
									{displayDialog === 1 && "Operazione completata con successo!"}
									{displayDialog === -1 && "Si è verificato un errore inatteso"}
								</DialogContentText>
						</DialogContent>
					</>
				)}
				<DialogActions>
					<Button onClick={handleClose}>Chiudi</Button>
				</DialogActions>
			</Dialog>


				{displayAlert === -1 && (
					<Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
				)}
			</Box>
		</>
	);
}

export default AppointmentList;
